module.exports = __webpack_public_path__ + "img/29.f1f0404b.svg";